// extracted by mini-css-extract-plugin
export var askAiIcon = "_oe-j";
export var category = "_oe-9";
export var categoryHeader = "_oe-e";
export var container = "_oe-0";
export var group = "_oe-a";
export var groupItems = "_oe-f";
export var groupSeparator = "_oe-k";
export var loading = "_oe-1";
export var noResults = "_oe-3";
export var placeholder = "_oe-2";
export var resultContent = "_oe-5";
export var resultIcon = "_oe-c";
export var resultItem = "_oe-g";
export var resultMeta = "_oe-8";
export var resultSubtitle = "_oe-7";
export var resultSuffix = "_oe-i";
export var resultTitle = "_oe-6";
export var resultsList = "_oe-4";
export var searchGroup = "_oe-d";
export var selected = "_oe-h";
export var subgroup = "_oe-b";